module.exports = __webpack_public_path__ + "img/img_32389_0_477.81f295ea.png";